module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/E-novels/e-novel-chapter/e-novel-chapter.component.css
// module id = ./src/app/E-novels/e-novel-chapter/e-novel-chapter.component.css
// module chunks = main